export default __webpack_public_path__ + "static/media/fav-blue.6f986c99.svg";